import React from "react";
import {
  Button,
  Grid,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Skeleton,
  Tooltip,
  Typography,
} from "@mui/material";
import { dateFormate, truncateComment } from "utils/utils";
import callIcon from "assets/images/callLogo.svg";
import mailIcon from "assets/images/mailLogo.svg";
import locationIcon from "assets/images/locationLogo.svg";
import calender from "assets/images/calender.svg";

function CustomerSubHeaderDetails(props) {
  const details = props?.details;
  return (
    <Grid className="customerAbout height270 overflowCard">
    <Grid
      item
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      xs={12}
    >
      <Grid
        item
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className="width100"
      >
        <Grid>
          <Typography
            className="fontBold font16 paddingTopBottom10"
            variant="h4"
          >
            About
          </Typography>
        </Grid>

        <Grid item>
          <Button variant="contained" className="vendorEditBtn">
            <span></span>
          </Button>
        </Grid>
      </Grid>
      <Grid item className="aboutCard">
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <Grid item alignItems={'center'} className="marginLeft15 subHeaderCardEmail mb15">
            <Grid display={'flex'}>
              <img src={mailIcon} alt="mail icon" fontSize="small" className="ml15" />
            </Grid>
            <Grid className="font16 marginInline textBreak">
              {details?.email ? details?.email : "Not Available"}
            </Grid>
          </Grid>
        )}
      </Grid>

      <Grid item>
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <Grid item alignItems={'center'} className="marginLeft15 subHeaderCard mb15">
            <Grid display={'flex'}>
              <img src={callIcon} alt="callIcon" fontSize="small" className="ml15" />
            </Grid>
            <Grid className="font16 marginInline textBreak">
              {details?.mobile ? details?.mobile : "Not Available"}
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item>
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <Grid item alignItems={'center'} className="marginLeft15 subHeaderCard mb15">
            <Grid display={'flex'}>
              <img src={locationIcon} alt="location" fontSize="small" className="ml15" />
            </Grid>
            <Grid className="font16 marginInline textBreak">
              {details?.location ? details?.location : "Not Available"}
            </Grid>
          </Grid>
        )}
      </Grid>
      <Grid item>
        {props?.loader ? (
          <Skeleton animation="wave" width={200} height={50} />
        ) : (
          <Grid item alignItems={'center'} className="marginLeft15 subHeaderCard mb15">
            <Grid display={'flex'}>
              <img src={calender} alt="calender" fontSize="small" className="ml15" />
            </Grid>
            <Grid className="font16 marginInline textBreak">
              {details?.createdAt
                ? dateFormate(details?.createdAt, "DD MMM YYYY")
                : "Not Available"}
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
    </Grid>
  );
}

export default CustomerSubHeaderDetails;
